import { Box, Flex } from '@chakra-ui/react';
import * as React from 'react';

import { tableToolbarDividerColor, tableToolbarGap, tableToolbarPaddingY } from './table-toolbar.kds';

export interface TableToolbarProps {
  /** Left-aligned slot — typically Search, dropdowns, and FilterTrigger. */
  children?: React.ReactNode;
  /** Right-aligned slot — typically icon buttons for export, column config, etc. */
  actions?: React.ReactNode;
}

export const TableToolbar = React.forwardRef<HTMLDivElement, TableToolbarProps>(function TableToolbar(props, ref) {
  const { children, actions } = props;

  return (
    <Flex
      ref={ref}
      align="center"
      justify="space-between"
      gap={tableToolbarGap}
      py={tableToolbarPaddingY}
      bg="neutral.0"
      data-testid="table-toolbar"
    >
      <Flex align="center" gap={tableToolbarGap} flexShrink={1} minW={0}>
        {children}
      </Flex>

      {actions && (
        <Flex align="center" gap="4px" flexShrink={0}>
          {actions}
        </Flex>
      )}
    </Flex>
  );
});
TableToolbar.displayName = 'TableToolbar';

export interface TableToolbarDividerProps {
  /** Override height. Defaults to full parent height (self-stretch). */
  height?: string;
}

export const TableToolbarDivider = React.forwardRef<HTMLDivElement, TableToolbarDividerProps>(
  function TableToolbarDivider(props, ref) {
    const { height } = props;

    return (
      <Box
        ref={ref}
        alignSelf="stretch"
        w="1px"
        bg={tableToolbarDividerColor}
        flexShrink={0}
        h={height}
        data-testid="table-toolbar-divider"
      />
    );
  }
);
TableToolbarDivider.displayName = 'TableToolbarDivider';
